import DateCell from '../../../../elements/Table/Cells/DateCell'
import moment from 'moment'
import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button, Tag } from 'antd'

function TrackingLinesList(props) {
  const { list, isUpdatable, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'Timeline',
      accessor: 'date',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{moment(value).fromNow()}</a>,
    },
    { Header: 'Created On', accessor: 'date', Cell: DateCell, width: 200 },
    { Header: 'Location', accessor: 'location' },
    {
      Header: 'Messages',
      accessor: 'messages',
      Cell: ({ value, original }) => (
        <>
          {value.map((i) => (
            <Tag color="#55acee">{i}</Tag>
          ))}
        </>
      ),
    },
    { Header: 'status', accessor: 'status' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={onShow}
          // disabled={!isUpdatable}
        >
          New
        </Button>
      )}
      defaultSorted={[{ id: 'date', desc: true }]}
      columns={columns}
    />
  )
}

TrackingLinesList.propTypes = {}
TrackingLinesList.defaultProps = {}

export default TrackingLinesList
